<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <h3 class="mb-3">
          {{ $t('host.label.birthDate') }}*
        </h3>
        <v-text-field
          v-model="dateLabel"
          dense
          outlined
          v-on="on"
          v-bind="attrs"
        />
      </template>
      <v-date-picker
        ref="picker"
        @change="handleDateSelect"
        v-model="selectedDate"
        :max="maxDate"
        :rules="rules"
        color="primary"
        :locale="localeLanguage"
        scrollable
        no-title
      />
    </v-menu>

    <VMessages :value="errorBucket" color="error" v-if="validationState" />
  </div>
</template>

<script>
import moment from 'moment'
import VInput from 'vuetify/lib/components/VInput/VInput.js'
const DATE_ONLY_FORMAT = 'DD/MM/YYYY'

export default {
  name: 'BirthDatePicker',
  extends: VInput,
  props: ['value', 'rules'],
  data() {
    return {
      selectedDate: null,
      dateLabel: null,
      date: null,
      menu: false,
      maxDate: moment().subtract(18, 'years').toISOString(),
    }
  },
  watch: {
    menu(val) {
      val &&
        setTimeout(() => {
          this.$refs.picker.activePicker = 'YEAR'
        })
    },

    value(val) {
      if (val) {
        this.selectedDate = val
        this.dateLabel = moment(this.selectedDate).format(DATE_ONLY_FORMAT)
      }
    },
  },
  mounted() {
    if (this.value) {
      this.selectedDate = this.value
      this.dateLabel = moment(this.selectedDate).format(DATE_ONLY_FORMAT)
    }
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date)
    },

    handleDateSelect() {
      this.dateLabel = moment(this.selectedDate).format(DATE_ONLY_FORMAT)
      this.$emit('input', `${this.selectedDate}T12:00:00Z`)
    },
  },
  computed: {
    localeLanguage() {
      return localStorage.getItem('user_language') ?? 'pt-BR'
    },
  },
}
</script>
